const PHRASE = "FOR CREATORS — AND BUSINESSES — ";

export default function Marquee() {
  return (
    <div
      data-testid="marquee-divider"
      className="overflow-hidden border-y border-[#0D0D0D]/10 py-5"
    >
      <div className="animate-marquee-slow flex w-max whitespace-nowrap">
        {[0, 1].map((n) => (
          <span
            key={n}
            aria-hidden={n === 1}
            className="font-mono-label text-xs tracking-[0.35em] text-[#8C8B85]"
          >
            {PHRASE.repeat(6)}
          </span>
        ))}
      </div>
    </div>
  );
}
